import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/styles';
import DateFnsUtils from '@date-io/date-fns';
import {
  Button,
  Card,
  CardHeader,
  CardContent,
  CardActions,
  Link,
  Divider,
  Modal,
  TextField,
  Grid,
  FormControl,
  MenuItem,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  Checkbox, CircularProgress,
} from '@material-ui/core';
import { Autocomplete } from "@material-ui/lab";
import _ from 'lodash';
import axios from 'axios';
import {
  MuiPickersUtilsProvider,
  DatePicker,
} from '@material-ui/pickers';
import qs from 'qs';
import PublisherForm from '../publishers/PublisherForm';
import useOpengraphData from "./useOpengraphData";
import useEffectExceptOnMount from "../../../helpers/useEffectExceptOnMount";
import RecentNews from "./RecentNews";
import CustomSnackbar from "../../user/shared/CustomSnackbar";

const useStyles = makeStyles((theme) => ({
  root: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    outline: 'none',
    boxShadow: theme.shadows[20],
    maxHeight: '100%',
    overflowY: 'auto',
    maxWidth: '100%'
  },
  cardHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  actions: {
    justifyContent: 'flex-end'
  },
  cardContent: {
    display: 'flex',
    flexDirection: 'column',
  }
}))

const PieceOfNewsForm = ({ adminUserSession, pieceOfNewsId, newsTypes, onClose, open, afterCreatePieceOfNews, onDataUpdate, itemIndex, ...props }) => {
  const classes = useStyles();

  const [pieceOfNews, setPieceOfNews] = useState({
    title: '',
    source_url: '',
    news_type: props.fixedTransaction && newsTypes.length > 0 ? newsTypes[0] : '',
    firm_ids:  !_.isEmpty(props.riaInvestorParents) ? props.riaInvestorParents.map(parent => parent.id)  : (!_.isEmpty(props.riaInvestorParent) ? [props.riaInvestorParent.id] : []) ,
    firm_type: undefined,
    item_contact_ids: [],
    item_contact_type: undefined,
    publisher_id: undefined,
    article_content: '',
    written_at: null,
    medium: '',
    associated_items: {},
    image_url: '',
    team_ids: props.fixedTeam ? [props.fixedTeam.id] : [],
    transaction_ids: props.fixedTransaction ? [props.fixedTransaction.id] : [],
    historical_blueprint_ids: [],
  });
  const [snackbar, setSnackbar] = useState({show: false, message: ''});

  useEffect(() => {
    if (_.isEmpty(pieceOfNews.firm_ids) && !_.isEmpty(pieceOfNews.item_contact_ids)) {
      setRiaInvestors({
        ...riaInvestors,
        disabled: true,
      })
    } else {
      setRiaInvestors({
        ...riaInvestors,
        disabled: (!_.isEmpty(props.riaInvestorParent) || !_.isEmpty(props.riaInvestorParents) ) ? true : false,
      })
    }

    if (pieceOfNewsId === undefined && _.isEmpty(pieceOfNews.firm_ids)) {
      setTeams({
        ...teams,
        disabled: true,
      })

      setTransactions({
        ...transactions,
        disabled: true,
      })
    }
  }, [pieceOfNews])

  const [selectedRiaInvestor, setSelectedRiaInvestor] = useState([]);
  const [selectedRiaContact, setSelectedRiaContact] = useState([]);
  const [selectedPublisher, setSelectedPublisher] = useState({});
  const [selectedTeam, setSelectedTeam] = useState([]);
  const [selectedTransaction, setSelectedTransaction] = useState([]);
  const [selectedHistoricalBlueprint, setSelectedHistoricalBlueprint] = useState([]);

  const [publishersData, setPublishersData] = useState({
    open: false,
    data: [],
  });
  const [riaInvestors, setRiaInvestors] = useState({
    open: false,
    disabled: false,
    data: [],
  });
  const [riaContacts, setRiaContacts] = useState({
    open: false,
    data: [],
  });

  const [teams, setTeams] = useState({
    open: false,
    disabled: false,
    data: [],
  });

  const [transactions, setTransactions] = useState({
    open: false,
    disabled: false,
    data: [],
  });

  const [historicalBlueprints, setHistoricalBlueprints] = useState({
    open: false,
    disabled: false,
    data: [],
  });

  useEffect(() => {
    if (props.fixedTeam && pieceOfNewsId === undefined) {
      setTeams({
        data: [props.fixedTeam],
        disabled: true,
      })

      if (!_.isEmpty(props.riaInvestorParent)) {
        setRiaInvestors({
          data: [props.riaInvestorParent],
          disabled: true,
        })

        setPieceOfNews({
          ...pieceOfNews,
          firm_type: 'RiaInvestor',
          associated_items: {
            RiaInvestor: [{id: props.riaInvestorParent.id, name: props.riaInvestorParent.name, type: 'RiaInvestor'}]
          }
        })
      }

      setTimeout(() => {
        if (!_.isEmpty(props.riaInvestorParent))
          setSelectedRiaInvestor([props.riaInvestorParent]);
        setSelectedTeam([props.fixedTeam]);
      },500)
    }
  }, []);

  useEffectExceptOnMount(() => {
    if (_.isEmpty(selectedRiaInvestor)) {
      setSelectedTeam([])
      setTeams({
        data: [],
        open: false,
        disabled: true,
      })
      setSelectedTransaction([])
      setTransactions({
        data: [],
        open: false,
        disabled: true,
      })
    }
  }, [selectedRiaInvestor])
  useEffectExceptOnMount(() => {
    if (_.isEmpty(selectedTeam)) {
      setSelectedHistoricalBlueprint([])
      setHistoricalBlueprints({
        data: [],
        open: false,
        disabled: true,
      })
    }
  }, [selectedTeam])


  useEffect(() => {
    if (props.fixedTransaction && pieceOfNewsId === undefined) {
      setTransactions({
        data: [props.fixedTransaction],
        disabled: true,
      });

      if (!_.isEmpty(props.riaInvestorParents)) {
        setRiaInvestors({
          data: props.riaInvestorParents,
          disabled: true,
        });

        setPieceOfNews((prev) => ({
          ...prev,
          firm_type: "RiaInvestor",
          associated_items: {
            RiaInvestor: props.riaInvestorParents.map(parent => ({
              id: parent.id,
              name: parent.name,
              type: "RiaInvestor",
            })),
          },
        }));
      }

      setTimeout(() => {
        if (!_.isEmpty(props.riaInvestorParents)) {
          setSelectedRiaInvestor(props.riaInvestorParents);
        }
        setSelectedTransaction([props.fixedTransaction]);
      }, 500);
    }
  }, [props.fixedTransaction, pieceOfNewsId]);

  const [errorMessage, setErrorMessage] = useState({});

  const [openPublisherForm, setOpenPublisherForm] = useState(false);

  const { loading, error, fetch, data } = useOpengraphData(adminUserSession);

  useEffectExceptOnMount(() => {
    const title = data.title;
    const forbidden_words = ['NASDAQ:', 'NYSE:', 'NYSEARCA:', 'LSE:', 'ACQUIRES SHARES OF']
    if (forbidden_words.some(word => title.toUpperCase().includes(word))) {
      const newErrorMessage = {...errorMessage};
      newErrorMessage['title'] = "This news is not allowed";
      setErrorMessage(newErrorMessage);
    }
    setPieceOfNews(prev => ({...prev, ...data}));
  }, [data])

  useEffect(() => {
    if (pieceOfNewsId !== undefined) {
      axios.get(
        `/v1/admin/news/${pieceOfNewsId}/edit`,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
            'X-Admin-User-Email': adminUserSession.email,
            'X-Admin-User-Token': adminUserSession.token
          }
        }
      ).then((response) => {
        const {
          piece_of_news,
          extra_data,
          status: responseStatus
        } = response.data;

        const {
          id,
          logo,
          created_at,
          updated_at,
          admin_user_id,
          publisher_photo_url,
          news_categories_names,
          ...itemParams
        } = piece_of_news;

        setPieceOfNews(itemParams);

        setSelectedRiaInvestor(extra_data.ria_investor);
        setSelectedRiaContact(extra_data.ria_contact);
        setSelectedPublisher(extra_data.publisher);
        setSelectedTeam(extra_data.teams);
        setSelectedTransaction(extra_data.transactions);
        setSelectedHistoricalBlueprint(extra_data.historical_blueprints);

        if (props.fixedTeam) {
          setTeams({
            ...teams,
            disabled: true,
          })
          setRiaInvestors({
            ...riaInvestors,
            disabled: true,
          })
        } else {
          setTeams({
            ...teams,
            disabled: false,
          })
        }

        if (props.fixedTransaction) {
          setTransactions({
            ...transactions,
            disabled: true,
          })
          setRiaInvestors({
            ...riaInvestors,
            disabled: true,
          })
        } else {
          setTransactions({
            ...transactions,
            disabled: false,
          })
        }
      }).catch(function (thrown) {
        console.log('error', thrown.message)
      });
    }
  }, [pieceOfNewsId])

  const handleCreatePieceOfNews = (pieceOfNews) => {
    axios.post(
      '/v1/admin/news',
      qs.stringify({ piece_of_news: pieceOfNews }),
      {
        headers: {
          'X-Admin-User-Email': adminUserSession.email,
          'X-Admin-User-Token': adminUserSession.token
        },
      }
    ).then((response) => {
      const {
        data: {
          status,
          message,
        }
      } = response;

      if (status === 'success') {
        afterCreatePieceOfNews();
      } else if (status === 'duplicated') {
        setSnackbar({show: true, message: message})
      } else {
        setErrorMessage(message);
        console.log('message', message)
      }
    })
  }

  const handleUpdatePieceOfNews = (pieceOfNews) => {
    axios.put(
      `/v1/admin/news/${pieceOfNewsId}`,
      qs.stringify({ piece_of_news: pieceOfNews }),
      {
        headers: {
          'Content-Type': 'multipart/form-data',
          'X-Admin-User-Email': adminUserSession.email,
          'X-Admin-User-Token': adminUserSession.token
        }
      }
    ).then((response) => {
      const {
        status: statusUpdate,
        message,
        piece_of_news,
      } = response.data;

      if (statusUpdate === 'success') {
        onDataUpdate(piece_of_news, itemIndex);
      } else if (statusUpdate === 'duplicated') {
        setSnackbar({show: true, message: message})
      } else {
        setErrorMessage(message);
        console.log('message', message)
      }
    });
  }

  const handleFetchPublishers = (params = {}) => {
    const newParams = {
      page: 1,
      per_page: 50,
      ...params
    };

    axios.get(
      '/v1/admin/news/publishers',
      {
        params: newParams,
        headers: {
          'Content-Type': 'multipart/form-data',
          'X-Admin-User-Email': adminUserSession.email,
          'X-Admin-User-Token': adminUserSession.token
        }
      }
    ).then((response) => {
      const { publishers, status: responseStatus } = response.data;

      setPublishersData({
        open: true,
        data: publishers,
      })
    });
  }

  const handleFetchRiaInvestors = (params = {}) => {
    const newParams = {
      page: 1,
      per_page: 50,
      ...params
    };

    axios.get(
      '/v1/admin/news/ria_investors',
      {
        params: newParams,
        headers: {
          'Content-Type': 'multipart/form-data',
          'X-Admin-User-Email': adminUserSession.email,
          'X-Admin-User-Token': adminUserSession.token
        }
      }
    ).then((response) => {
      const { ria_investors, status: responseStatus } = response.data;

      setRiaInvestors({
        open: true,
        data: ria_investors,
      })
    });
  }

  const handleFetchRiaContacts = (params = {}) => {
    const newParams = {
      page: 1,
      per_page: 50,
      ...params
    };

    axios.get(
      '/v1/admin/news/ria_contacts',
      {
        params: newParams,
        headers: {
          'Content-Type': 'multipart/form-data',
          'X-Admin-User-Email': adminUserSession.email,
          'X-Admin-User-Token': adminUserSession.token
        }
      }
    ).then((response) => {
      const { ria_contacts, status: responseStatus } = response.data;

      setRiaContacts({
        open: true,
        data: ria_contacts,
      })
    });
  }

  const handleOnChangeTitle = (event) => {
    event.persist();
    const forbidden_words = ['NASDAQ:', 'NYSE:', 'NYSEARCA:', 'LSE:', 'ACQUIRES SHARES OF']
    const title = event.target.value;
    if (forbidden_words.some(word => title.toUpperCase().includes(word))) {
      const newErrorMessage = {...errorMessage};
      newErrorMessage['title'] = "This news is not allowed";
      setErrorMessage(newErrorMessage);
    } else {
      const newErrorMessage = {...errorMessage};
      if (newErrorMessage['title']) {
        delete newErrorMessage['title']
        setErrorMessage(newErrorMessage);
      }
    }
    setPieceOfNews(prevState => ({
      ...prevState,
      ['title']: title,
    }));
  }

  const handleOnBodyChange = (event) => {
    event.persist();
    const forbidden_words = selectedHistoricalBlueprint.length > 0 ? [] : ['NASDAQ:', 'NYSE:', 'NYSEARCA:', 'LSE:', 'ACQUIRES SHARES OF']
    const body = event.target.value;
    if (forbidden_words.some(word => body.toUpperCase().includes(word))) {
      const newErrorMessage = {...errorMessage};
      newErrorMessage['article_content'] = "This news is not allowed";
      setErrorMessage(newErrorMessage);
    } else {
      const newErrorMessage = {...errorMessage};
      if (newErrorMessage['article_content']) {
        delete newErrorMessage['article_content']
        setErrorMessage(newErrorMessage);
      }
    }
    setPieceOfNews(prevState => ({
      ...prevState,
      ['article_content']: body,
    }));
  }



  const handleOnChange = (event) => {
    event.persist();

    setPieceOfNews(prevState => ({
      ...prevState,
      [event.target.name]: event.target.value,
    }));
  }

  const handleInputChangeAutocomplete = (event, field) => {
    event.persist();
    debounceFilterInput(event, field);
  }

  const debounceFilterInput = _.debounce((event,field) => {
    switch (field) {
      case 'publisher_id':
        handleFetchPublishers({ filter: event.target.value, publisher_id: pieceOfNews.publisher_id })
        break;
      case 'firm_ids':
        handleFetchRiaInvestors({ filter: event.target.value, ria_investor_id: pieceOfNews.firm_ids })
        break;
      case 'item_contact_ids':
        handleFetchRiaContacts({ filter: event.target.value, ria_investor_id: pieceOfNews.firm_ids, ria_contact_id: pieceOfNews.item_contact_ids })
        break;
      case 'team_ids':
        handleFetchTeams({ filter: event.target.value, firm_ids: pieceOfNews.firm_ids, team_ids: pieceOfNews.team_ids })
        break;
      case 'transaction_ids':
        handleFetchTransactions({ filter: event.target.value, firm_ids: pieceOfNews.firm_ids, transaction_ids: pieceOfNews.transaction_ids })
        break;
      case 'historical_blueprint_ids':
        handleFetchHistoricalBlueprints({ filter: event.target.value, team_ids: pieceOfNews.team_ids, historical_blueprint_ids: pieceOfNews.historical_blueprint_ids })
        break;
    }
  }, 500)

  const hadleOpenPublishers = (open) => {
    if (open === true) {
      handleFetchPublishers({ publisher_id: pieceOfNews.publisher_id })
    } else {
      setPublishersData({
        open: false,
        data: [],
      })
    }
  }

  const hadleOpenRiaInvestors = (open) => {
    if (open === true) {
      handleFetchRiaInvestors({ ria_investor_id: pieceOfNews.firm_ids })
    } else {
      setRiaInvestors({
        open: false,
        data: [],
      })
    }
  }

  const hadleOpenTeams = (open) => {
    if (open === true) {
      handleFetchTeams({ team_ids: pieceOfNews.team_ids, firm_ids: pieceOfNews?.firm_ids })
    } else {
      setTeams({
        open: false,
        data: [],
      })
    }
  }
  const hadleOpenTransactions = (open) => {
    if (open === true) {
      handleFetchTransactions({ transaction_ids: pieceOfNews.transaction_ids, firm_ids: pieceOfNews?.firm_ids })
    } else {
      setTransactions({
        open: false,
        data: [],
      })
    }
  }
  const hadleOpenRiaContacts = (open) => {
    if (open === true && pieceOfNews?.firm_ids !== undefined) {
      handleFetchRiaContacts({ ria_investor_id: pieceOfNews.firm_ids, ria_contact_id: pieceOfNews.item_contact_ids })
    } else {
      setRiaContacts({
        open: false,
        data: [],
      })
    }
  }

  const handleFetchTeams = (params = {}, open = true) => {
    if (!_.isEmpty(props.fixedTeam))
      return

    axios.get(
        '/v1/admin/news/teams',
        {
          params: params,
          headers: {
            'Content-Type': 'multipart/form-data',
            'X-Admin-User-Email': adminUserSession.email,
            'X-Admin-User-Token': adminUserSession.token
          }
        }
    ).then((response) => {
      const { teams, status: responseStatus } = response.data;

      setTeams({
        open: open && !!teams?.length,
        data: teams,
        disabled: false
      })

      const filteredTeams = pieceOfNews.team_ids.filter(teamId =>
          teams.some(team => team.id === teamId)
      );
      const fieldData = {
        team_ids: filteredTeams,
      }

      setPieceOfNews(prevState => ({
        ...prevState,
        ...fieldData,
      }));

    });
  }

  const handleFetchTransactions = (params = {}, open = true) => {
    if (!_.isEmpty(props.fixedTransaction))
      return

    axios.get(
        '/v1/admin/news/transactions',
        {
          params: params,
          headers: {
            'Content-Type': 'multipart/form-data',
            'X-Admin-User-Email': adminUserSession.email,
            'X-Admin-User-Token': adminUserSession.token
          }
        }
    ).then((response) => {
      const { transactions, status: responseStatus } = response.data;

      setTransactions({
        open: open && !!transactions?.length,
        data: transactions,
        disabled: false
      })

      const filteredTransactions = pieceOfNews.transaction_ids.filter(transactionId =>
          transactions.some(transaction => transaction.id === transactionId)
      );
      const fieldData = {
        transaction_ids: filteredTransactions,
      }

      setPieceOfNews(prevState => ({
        ...prevState,
        ...fieldData,
      }));

    });
  }

  const handleFetchHistoricalBlueprints = (params = {}, open = true) => {
    if (!!params.team_ids && _.isEmpty(params.team_ids)) {
      setHistoricalBlueprints({...historicalBlueprints, data: []})
      return
    }
    axios.get(
        '/v1/admin/news/historical_blueprints',
        {
          params: params,
          headers: {
            'Content-Type': 'multipart/form-data',
            'X-Admin-User-Email': adminUserSession.email,
            'X-Admin-User-Token': adminUserSession.token
          }
        }
    ).then((response) => {
      const { historical_blueprints, status: responseStatus } = response.data;

      setHistoricalBlueprints({
        open: open && !!historical_blueprints?.length,
        data: historical_blueprints,
        disabled: false
      })

      const filteredHistoricalBlueprints = pieceOfNews.historical_blueprint_ids.filter(historicaId =>
          historical_blueprints.some(hist => hist.id === historicaId)
      );
      const fieldData = {
        historical_blueprint_ids: filteredHistoricalBlueprints,
      }

      setPieceOfNews(prevState => ({
        ...prevState,
        ...fieldData,
      }));

    });
  }

  const handleOnChangeAutocomplete = (field, selectedValue) => {
    let fieldData = {};

    let associatedItems = { ...pieceOfNews.associated_items };

    switch (field) {
      case 'firm_ids':
        const firm_ids = selectedValue.map((item) => item.id)
        handleFetchTeams({firm_ids: firm_ids}, false);
        handleFetchTransactions({firm_ids: firm_ids}, false);
        fieldData = {
          firm_type: !_.isEmpty(selectedValue.map((item) => item.id)) ? 'RiaInvestor' : undefined,
          firm_ids: firm_ids,
          associated_items: {
            ...associatedItems,
            RiaInvestor: selectedValue.map((item) => ({ id: item.id, name: item.name, type: 'RiaInvestor' })),
          }
        }

        setSelectedRiaInvestor(selectedValue);
        break;
      case 'item_contact_ids':
        fieldData = {
          item_contact_type: !_.isEmpty(selectedValue.map((item) => item.id)) ? 'RiaContact' : undefined,
          item_contact_ids: selectedValue.map((item) => item.id),
          associated_items: {
            ...associatedItems,
            RiaContact: selectedValue.map((item) => ({ id: item.id, name: item.name, type: 'RiaContact' })),
          }
        }

        setSelectedRiaContact(selectedValue);
        break;
      case 'publisher_id':
        fieldData = {
          publisher_id: selectedValue?.id,
          publisher_name: selectedValue?.name,
        }

        setSelectedPublisher(selectedValue);
        break;
      case 'team_ids':
        const team_ids = selectedValue.map((item) => item.id)
          handleFetchHistoricalBlueprints({team_ids: team_ids}, false);
        fieldData = {
          team_ids: team_ids,
        }

        setSelectedTeam(selectedValue);
        break;
      case 'transaction_ids':
        fieldData = {
          transaction_ids: selectedValue.map((item) => item.id),
        }

        setSelectedTransaction(selectedValue);
        break;
      case 'historical_blueprint_ids':
        fieldData = {
          historical_blueprint_ids: selectedValue.map((item) => item.id),
        }

        setSelectedHistoricalBlueprint(selectedValue);
        break;
    }

    setPieceOfNews(prevState => ({
      ...prevState,
      ...fieldData,
    }));
  }

  const handleDateChange = (date) => {
    setPieceOfNews(prevState => ({
      ...prevState,
      written_at: date,
    }));
  }

  const handleSubmit = (event) => {
    event.persist();
    event.preventDefault();

    const blankValues = Object.keys(_.pickBy(pieceOfNews, (item) => ([null, undefined, ''].includes(item) || (item.constructor.name === 'Array' && _.isEmpty(item)))));

    if (
        (_.isEmpty(pieceOfNews.firm_ids) && _.isEmpty(pieceOfNews.item_contact_ids)) || !_.isEmpty(errorMessage['title']) || !_.isEmpty(errorMessage['article_content']) ||
        !_.isEmpty(_.intersection(blankValues, ['title', 'source_url', 'news_type', 'publisher_id', 'written_at', 'article_content', 'medium']))
    ) {
      const message = {...errorMessage};

      blankValues.forEach((value) => {
        message[value] = "Can't be blank!"
      })

      console.log('message', message)

      setErrorMessage(message);
    } else if (pieceOfNewsId !== undefined) {
      handleUpdatePieceOfNews(pieceOfNews);
    } else {
      handleCreatePieceOfNews(pieceOfNews);
    }
  }

  const handleOpenNewPublisherModal = () => {
    setOpenPublisherForm(true);
  }

  const handleCloseNewPublisherModal = () => {
    setOpenPublisherForm(false);
  }

  const hadleOpenHistoricalBlueprints = (open) => {
    if (open === true) {
      handleFetchHistoricalBlueprints({ historical_blueprint_ids: pieceOfNews.historical_blueprint_ids, team_ids: pieceOfNews?.team_ids })
    } else {
      setHistoricalBlueprints({
        open: false,
        data: [],
      })
    }
  }

  const afterCreatePublisher = (publisher) => {
    setSelectedPublisher(publisher);

    setPieceOfNews(prevState => ({
      ...prevState,
      publisher_id: publisher?.id,
    }));
  }

  const handleOnClose = (event, reason) => {
    if (reason !== 'backdropClick') {
      onClose();
    }
  }

  const formatValueForDatePicker = () => {
    if (pieceOfNews.written_at && (typeof pieceOfNews.written_at === 'string' || pieceOfNews.written_at instanceof String)) {
        return   new Date (pieceOfNews.written_at?.replace(/-/, '/').replace(/-/, '/'))
    }
   return  pieceOfNews.written_at
  }

  return(
    <Modal
      onClose={handleOnClose}
      open={open}
    >
      <>
      <Card
        className={classes.root}
      >
        <CardHeader title='Piece Of News RIA' />
        <Divider />
        <CardContent>
          <Grid container spacing={3} >
            <Grid
                item

                xs={12}
            >
              <FormControl fullWidth>
                <TextField
                    label="Source URL"
                    variant="outlined"
                    name='source_url'
                    required
                    value={pieceOfNews.source_url || ''}
                    onChange={(e) => {
                      fetch(e.target.value);
                      handleOnChange(e);
                    }}
                />
                {
                  loading ? (<div style={{display: "inline-flex", verticalAlign: "center"}}>
                    <CircularProgress size={20}/>
                    <span style={{paddingLeft: 10, fontWeight: "normal", fontStyle: "italic"}}>Fetching metadata (title and image)</span>
                  </div>) : null
                }
                {
                  error ? (<span style={{paddingLeft: 10, fontWeight: "normal", fontStyle: "italic", color: "red"}}>Error fetching metadata, please fill in the title manually.</span>) : null
                }
                <span>{errorMessage['source_url']}</span>
              </FormControl>
            </Grid>
            <Grid
              item

              xs={12}
            >
              <FormControl fullWidth>
                <TextField
                  label="Title"
                  variant="outlined"
                  name='title'
                  required
                  inputProps={{ maxLength: 500  }}
                  value={pieceOfNews.title || ''}
                  onChange={handleOnChangeTitle}
                />
                <span>{errorMessage['title']}</span>
              </FormControl>
            </Grid>



            {
              (pieceOfNews.image_url) ?(
                  <Grid style={{textAlign: "center"}}
                    item xs={12}>
                    <img

                        src={pieceOfNews.image_url}
                        style={{width: 300, height: 200, objectFit: "scale-down",
                          borderWidth:1, borderColor: '#707070', borderStyle: "solid"}}
                        alt={pieceOfNews.title}
                        loading="lazy"
                    />
                  </Grid>
                ) : null
            }

            <Grid
              item

              xs={12}
            >
              <FormControl fullWidth>
                <TextField
                  select
                  fullWidth
                  required
                  variant='outlined'
                  value={props.fixedTransaction && newsTypes.length > 0 ? newsTypes[0] : pieceOfNews.news_type}
                  label='News Type'
                  name='news_type'
                  onChange={handleOnChange}
                  disabled={!!props.fixedTransaction}
                >
                  <MenuItem value="">
                    <em>Chose a Type</em>
                  </MenuItem>
                  {
                    newsTypes.map((type, index) => <MenuItem key={`${type}-${index}`} value={type}>{type}</MenuItem>)
                  }
                </TextField>
                <span>{errorMessage['news_type']}</span>
              </FormControl>
            </Grid>

            <Grid
              item

              xs={12}
            >
              <Autocomplete
                multiple
                filterSelectedOptions={true}
                name="firm_ids"
                open={riaInvestors.open}
                onOpen={(event) => hadleOpenRiaInvestors(true)}
                onClose={(event) => hadleOpenRiaInvestors(false)}
                onChange={(event, value) => handleOnChangeAutocomplete('firm_ids', value)}
                getOptionSelected={(option, value) => option.id === value.id}
                getOptionLabel={(option) => (option.name && option.crd_id) ? `${option.name} #${option.crd_id}` : option.name || ''}
                value={selectedRiaInvestor}
                options={riaInvestors.data || []}
                disabled={riaInvestors.disabled}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="RIA Entity"
                    variant="outlined"
                    onKeyDown={(event) => event.key === 'Enter' ? event.stopPropagation() : event.persist()}
                    onChange={(event) => handleInputChangeAutocomplete(event, 'firm_ids')}
                  />
                )}
              />
              <span>{errorMessage['firm_ids']}</span>
            </Grid>

            <Grid
                item
                xs={12}
            >
              <Autocomplete
                  multiple
                  filterSelectedOptions={true}
                  name="team_ids"
                  open={teams.open}
                  onOpen={(event) => hadleOpenTeams(true)}
                  onClose={(event) => hadleOpenTeams(false)}
                  onChange={(event, value) => handleOnChangeAutocomplete('team_ids', value)}
                  getOptionSelected={(option, value) => option.id === value.id}
                  getOptionLabel={(option) => option.team_name || ''}
                  value={selectedTeam}
                  options={teams.data || []}
                  disabled={teams.disabled}
                  renderInput={(params) => (
                      <TextField
                          {...params}
                          label="Wealth Teams"
                          variant="outlined"
                          onKeyDown={(event) => event.key === 'Enter' ? event.stopPropagation() : event.persist()}
                          onChange={(event) => handleInputChangeAutocomplete(event, 'team_ids')}
                      />
                  )}
              />
            </Grid>

            <Grid
                item
                xs={12}
            >
              <Autocomplete
                  multiple
                  filterSelectedOptions={true}
                  name="transaction_ids"
                  open={transactions.open}
                  onOpen={(event) => hadleOpenTransactions(true)}
                  onClose={(event) => hadleOpenTransactions(false)}
                  onChange={(event, value) => handleOnChangeAutocomplete('transaction_ids', value)}
                  getOptionSelected={(option, value) => option.id === value.id}
                  getOptionLabel={(option) => option.acquired_firm_name + " --> " + option.acquiring_firm_name +" (M/A"+ option.id + ")"  || ''}
                  value={selectedTransaction}
                  options={transactions.data || []}
                  disabled={transactions.disabled}
                  renderInput={(params) => (
                      <TextField
                          {...params}
                          label="M&A Transactions"
                          variant="outlined"
                          onKeyDown={(event) => event.key === 'Enter' ? event.stopPropagation() : event.persist()}
                          onChange={(event) => handleInputChangeAutocomplete(event, 'transaction_ids')}
                      />
                  )}
              />
            </Grid>


            <Grid
                item
                xs={12}
            >
              <Autocomplete
                  multiple
                  filterSelectedOptions={true}
                  name="historical_blueprint_ids"
                  open={historicalBlueprints.open}
                  onOpen={(event) => hadleOpenHistoricalBlueprints(true)}
                  onClose={(event) => hadleOpenHistoricalBlueprints(false)}
                  onChange={(event, value) => handleOnChangeAutocomplete('historical_blueprint_ids', value)}
                  getOptionSelected={(option, value) => option.id === value.id}
                  getOptionLabel={(option) => option.previous_team_name + " (Former CRD ID "+ option?.previous_parent_company_crd_id + ")"  || ''}
                  value={selectedHistoricalBlueprint}
                  options={historicalBlueprints.data || []}
                  disabled={historicalBlueprints.disabled}
                  renderInput={(params) => (
                      <TextField
                          {...params}
                          label="Historical Blueprints"
                          variant="outlined"
                          onKeyDown={(event) => event.key === 'Enter' ? event.stopPropagation() : event.persist()}
                          onChange={(event) => handleInputChangeAutocomplete(event, 'historical_blueprint_ids')}
                      />
                  )}
              />
            </Grid>


            <Grid
              item

              xs={12}
            >
              <Autocomplete
                multiple
                filterSelectedOptions={true}
                name="item_contact_ids"
                open={riaContacts.open}
                onOpen={(event) => hadleOpenRiaContacts(true)}
                onClose={(event) => hadleOpenRiaContacts(false)}
                onChange={(event, value) => handleOnChangeAutocomplete('item_contact_ids', value)}
                getOptionSelected={(option, value) => option.id === value.id}
                getOptionLabel={(option) => (option.name && option.crd_id) ? `${option.name} #${option.crd_id}` : option.name || ''}
                value={selectedRiaContact}
                options={riaContacts.data || []}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="RIA Contact"
                    variant="outlined"
                    onKeyDown={(event) => event.key === 'Enter' ? event.stopPropagation() : event.persist()}
                    onChange={(event) => handleInputChangeAutocomplete(event, 'item_contact_ids')}
                  />
                )}
              />
              <span>{errorMessage['item_contact_ids']}</span>
            </Grid>

            <Grid
              item

              xs={12}
            >
              <div>
                <Autocomplete
                  name="publisher_id"
                  open={publishersData.open}
                  onOpen={(event) => hadleOpenPublishers(true)}
                  onClose={(event) => hadleOpenPublishers(false)}
                  onChange={(event, value) => handleOnChangeAutocomplete('publisher_id', value)}
                  getOptionSelected={(option, value) => option.id === value.id}
                  getOptionLabel={(option) => option.name || ''}
                  value={selectedPublisher}
                  options={publishersData.data || []}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Publisher"
                      variant="outlined"
                      onKeyDown={(event) => event.key === 'Enter' ? event.stopPropagation() : event.persist()}
                      onChange={(event) => handleInputChangeAutocomplete(event, 'publisher_id')}
                    />
                  )}
                />
                <Link onClick={handleOpenNewPublisherModal}>New Publisher</Link>
              </div>
              <span>{errorMessage['publisher_id']}</span>
            </Grid>

            <Grid
              item

              xs={12}
            >
              <FormControl
                component="fieldset"
                fullWidth
              >
                <FormLabel component="legend">News Medium</FormLabel>
                <RadioGroup aria-label="medium" name="medium" value={pieceOfNews.medium || ''} onChange={handleOnChange}>
                  <FormControlLabel value="written" control={<Radio required />} label="Written" />
                  <FormControlLabel value="video" control={<Radio required />} label="Video" />
                </RadioGroup>
              </FormControl>
            </Grid>

            <Grid
              item

              xs={12}
            >
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <DatePicker
                  disableToolbar
                  disableFuture
                  inputVariant="outlined"
                  label="Written At"
                  value={formatValueForDatePicker()}
                  onChange={handleDateChange}
                  format="yy-MM-dd"
                  openTo="year"
                  views={['year', 'month', 'date']}
                />
              </MuiPickersUtilsProvider>
              <span>{errorMessage['written_at']}</span>
            </Grid>

            <Grid
              item

              xs={12}
            >
              <TextField
                fullWidth
                required
                label="Article Content"
                variant="outlined"
                name={'article_content'}
                onChange={handleOnBodyChange}
                value={pieceOfNews.article_content}
                multiline={true}
                rows={8}
              />
              <span>{errorMessage['article_content']}</span>
            </Grid>
          </Grid>
        </CardContent>
        <Divider />
        <CardActions>
          <Button onClick={onClose}>Close</Button>
          <Button color="primary" variant="contained" onClick={handleSubmit}>Save</Button>
        </CardActions>

        {
          openPublisherForm ?
            <PublisherForm
              adminUserSession={adminUserSession}
              onClose={handleCloseNewPublisherModal}
              open={openPublisherForm}
              afterCreatePublisher={afterCreatePublisher}
            />
            : null
        }
      </Card>
        <RecentNews classes={classes}
                    selectedInvestor={selectedRiaInvestor}
                    selectedContact={selectedRiaContact}
                    adminUserSession={adminUserSession}
                    dataset={'RIA'}
        />
        <CustomSnackbar
            open={snackbar.show}
            closeHandler={() => setSnackbar({show: false, message: ''})}
            message={snackbar.message}
            options={{
              severity: 'warning'
            }}
        />
      </>
    </Modal>
  )
}

export default PieceOfNewsForm;